import { doc, serverTimestamp, updateDoc } from "firebase/firestore";
import { db } from "../../../lib/firebase";
import type { SmartTagAttachmentFile, VCard } from "../../../types/vcard";

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === "object" && value !== null && !Array.isArray(value);

export const getBootsWarrantyFiles = (
  formData: Partial<VCard>,
): SmartTagAttachmentFile[] => {
  const categorySpecificInfo = formData.categorySpecificInfo;
  if (!isRecord(categorySpecificInfo)) {
    return [];
  }

  const snowGear = categorySpecificInfo.snowGear;
  if (!isRecord(snowGear)) {
    return [];
  }

  const boots = snowGear.boots;
  if (!isRecord(boots)) {
    return [];
  }

  const attachments = boots.attachments;
  if (!isRecord(attachments)) {
    return [];
  }

  const warranty = attachments.warranty;
  if (!isRecord(warranty) || !Array.isArray(warranty.files)) {
    return [];
  }

  return warranty.files as SmartTagAttachmentFile[];
};

export const withBootsWarrantyFiles = (
  formData: Partial<VCard>,
  files: SmartTagAttachmentFile[],
): Partial<VCard> => {
  const categorySpecificInfo = isRecord(formData.categorySpecificInfo)
    ? formData.categorySpecificInfo
    : {};
  const snowGear = isRecord(categorySpecificInfo.snowGear)
    ? categorySpecificInfo.snowGear
    : {};
  const boots = isRecord(snowGear.boots) ? snowGear.boots : {};
  const attachments = isRecord(boots.attachments) ? boots.attachments : {};
  const warranty = isRecord(attachments.warranty) ? attachments.warranty : {};

  return {
    ...formData,
    categorySpecificInfo: {
      ...categorySpecificInfo,
      snowGear: {
        ...snowGear,
        boots: {
          ...boots,
          attachments: {
            ...attachments,
            warranty: {
              ...warranty,
              files,
            },
          },
        },
      },
    },
  };
};

export const persistBootsWarrantyFiles = async (
  userId: string,
  files: SmartTagAttachmentFile[],
): Promise<void> => {
  const vcardRef = doc(db, `users/${userId}/vcards/active`, "snowGear_boots");
  await updateDoc(vcardRef, {
    "categorySpecificInfo.snowGear.boots.attachments.warranty.files": files,
    updatedAt: serverTimestamp(),
  });
};
